import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, Modal, ModalBody } from "reactstrap";
import {
	Form,
	FormGroup,
	Row,
	Col,
	Input,
	FormFeedback,
	Label,
} from "reactstrap";
import { useFormik } from "formik";
import moment from "moment";
import * as Yup from "yup";
import ataEncaminhamentosService from "services/AtaEncaminhamentosService";
import { FloppyDisk, SignOut } from "@phosphor-icons/react";

const ModalChangePrazo = ({
	show,
	onCloseClick,
	data,
	closeModalsOnChangePrazo,
}) => {
	const [prazoChanges, setPrazoChanges] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			ata_referrals_id: data?.id,
		},
		validationSchema: Yup.object({
			deadline: Yup.string().required(
				"Por favor, informe o Alterar para!",
			),
			content: Yup.string().required(
				"Por favor, informe a Justificativa!",
			),
		}),

		onSubmit: async (values) => {
			let val = values;
			setIsLoading(true);
			await ataEncaminhamentosService.postPrazo(val);
			setIsLoading(false);
			closeModalsOnChangePrazo();
		},
	});

	async function getChanges() {
		try {
			const response = await ataEncaminhamentosService.getPrazoChanges(
				data.id,
			);
			setPrazoChanges(response);
		} catch (error) {
			console.log(error);
		}
	}

	useEffect(() => {
		getChanges();
	}, [show]);

	return (
		<Modal
			size="sm"
			isOpen={show}
			toggle={onCloseClick}
			centered={true}
			style={{ minWidth: 800 }}
			zIndex={1500}
		>
			<div className="modal-content">
				<ModalBody className="px-4 py-3 text-center">
					<Col md="12">
						<Form
							className="needs-validation"
							onSubmit={(e) => {
								e.preventDefault();
								validation.handleSubmit();
								return false;
							}}
						>
							<h4 className="text-center my-4">Alterar Prazo</h4>
							<h4 className="text-center my-4">
								{data?.referrals}
							</h4>

							<Row>
								<Col md="6">
									<FormGroup className="mb-3">
										<Label htmlFor="validationCustom01">
											Alterar para
										</Label>
										<Input
											name="deadline"
											placeholder="Data"
											type="date"
											className="form-control"
											id="validationCustom01"
											onChange={validation.handleChange}
											onBlur={validation.handleBlur}
											value={
												validation.values.deadline || ""
											}
											invalid={
												validation.touched.deadline &&
												validation.errors.deadline
											}
										/>
										{validation.errors.deadline ? (
											<FormFeedback type="invalid">
												{validation.errors.deadline}
											</FormFeedback>
										) : null}
									</FormGroup>
									<FormGroup className="mb-3">
										<Label htmlFor="content">
											Justificativa
										</Label>
										<Input
											name="content"
											type="textarea"
											placeholder="Descrição"
											onChange={validation.handleChange}
											onBlur={validation.handleBlur}
											value={
												validation.values.content || ""
											}
											invalid={validation.errors.content}
										/>
										{validation.touched.content &&
										validation.errors.content ? (
											<FormFeedback type="invalid">
												{validation.errors.content}
											</FormFeedback>
										) : null}
									</FormGroup>
								</Col>
								<Col md="6">
									<p>
										{moment(data.deadline).format(
											"DD/MM/YYYY",
										)}{" "}
										- <b>Prazo Atual</b>{" "}
										{moment(data.original_deadline).format(
											"DD/MM/YYYY",
										)}{" "}
										- <b>Prazo Inicial</b>
									</p>
									{prazoChanges.length > 0 && (
										<p
											style={{
												fontSize: 16,
												fontWeight: "bold",
											}}
										>
											Prorrogações
										</p>
									)}
									{prazoChanges.map((item) => (
										<p>
											{moment(item.deadline).format(
												"DD/MM/YYYY",
											)}{" "}
											- {item.content}
										</p>
									))}
								</Col>
							</Row>

							<Row className="py-1">
								<div className="hstack gap-2 justify-content-center mb-0">
									<Button
										style={{
											background: "none",
											padding: 10,
											cursor: "pointer",
											color: "black",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											gap: 2,
										}}
										type="submit"
									>
										{isLoading ? (
											<span
												className="spinner-border spinner-border-sm mr-1"
												style={{ marginRight: 10 }}
											></span>
										) : null}
										<FloppyDisk size={16} /> Salvar
									</Button>
									<Button
										type="button"
										style={{
											background: "none",
											padding: 10,
											cursor: "pointer",
											color: "black",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											gap: 2,
										}}
										onClick={onCloseClick}
									>
										<SignOut size={16} /> Fechar
									</Button>
								</div>
							</Row>
						</Form>
					</Col>
				</ModalBody>
			</div>
		</Modal>
	);
};

ModalChangePrazo.propTypes = {
	show: PropTypes.bool,
	onCloseClick: PropTypes.func,
	data: PropTypes.any,
};

export default ModalChangePrazo;
